import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'outsourceController';
export default {
    /**
     * 委外方列表
     */
    searchCutsourceList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'searchCutsourceList',
        type: requestType.Get
    },
    /**
     *  修改委外方
     */
    modifyCutsource: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'modifyCutsource',
        type: requestType.Post
    },
};
